import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import { deleteLSMAcceptanceReason, disableAddModal, enableAddModal, fetchAllLSMAcceptanceReasons, selectBmrAddLSMAcceptanceReasonModal, selectLSMAcceptanceReasonsAll, selectLSMAcceptanceReasonsLoading } from "../../../slices/lsmAcceptanceReason";
import LSMAcceptanceReasonForm from "./LSMAcceptanceReasonForm";

const LSMAcceptanceReason = () => {
    const dispatch = useDispatch()
    const isLoading = useSelector(selectLSMAcceptanceReasonsLoading)
    const addModal = useSelector(selectBmrAddLSMAcceptanceReasonModal)
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const allLSMAcceptanceReasons = useSelector(selectLSMAcceptanceReasonsAll)

    const columns = [
        {
            id: 'name',
            name: 'Name',
            align: "center",

            selector: row => row.name,
            sortable: true
        },
        {
            id: 'description',
            name: 'Description',
            align: "center",

            selector: row => row.description,
            sortable: true
        },
        {
            id: 'type',
            name: 'Status',
            align: "center",
            selector: row => row.active ? <Typography className="text-[#369c50]">Active</Typography> : <Typography className="text-[#FF2023]">In-Active</Typography>,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), setOpen(true) }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];


    const fetchData = async () => {
        await dispatch(disableAddModal())
        await dispatch(fetchAllLSMAcceptanceReasons())
    }

    useEffect(() => {
        fetchData()
    }, []);
    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeLSMAcceptanceReason = async () => {
        const { id } = rowData
        await dispatch(deleteLSMAcceptanceReason({ id }))
        setOpen(false)
    }

    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal open={addModal} onClose={handleCloseModal} title={rowData ? "Edit LSM Acceptance Reason" : "Add LSM Acceptance Reason"}>
                <LSMAcceptanceReasonForm editData={rowData} />
            </BsModal>
            <Datatable
                columns={columns}
                data={allLSMAcceptanceReasons}
                title="LSM Acceptance Reason"
                searchPlaceholder="Search by Name"
                loading={isLoading}
                BtnComponent={<Button className="ml-2" onClick={() => (handleAddModal(), setRowData(null))}>Add New Reason</Button>}
            // remote={false}
            // onServerSideChange={updateFilter}
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeLSMAcceptanceReason}
            />
        </div>
    </div>
}
export default LSMAcceptanceReason